import loadable from '@loadable/component';

import { BoxIndicator } from '@classtinginc/design-system';

const CreateClassroomPage = loadable(() => import('./CreateClassroomPage'), {
  fallback: <BoxIndicator />,
});

export default CreateClassroomPage;
